module.exports = __webpack_public_path__ + "img/nutanix.87666923.svg";